import { Injectable } from '@angular/core';
import { CpfModel } from 'src/app/shared/service/cpf/model/cpf.model';
import { CpfDataService } from './cpf-data.service';

@Injectable({
  providedIn: 'root'
})
export class CpfMockService implements CpfDataService{

  readonly cpfAll = [];

  constructor() {
    this.cpfAll.push(this.getCpfValid());
    this.cpfAll.push(this.getCpfFalse());
  }

  public getCpf(cpfId: string): Promise<CpfModel> {
    const cpfFound = this.cpfAll.find((r: { code: string; data: CpfModel }) => r.code === cpfId || r.code === '');
    if (cpfFound) {
      return Promise.resolve(cpfFound.data);
    } else {
      return Promise.resolve(null);
    }
  }

  protected getCpfValid() {
    return {
      code : '35855371820',
      data: {
        success: true,
      }
    };
  }

  protected getCpfFalse() {
    return {
      code : '35855571820',
      data: {
        success: false,
      }
    };
  }
}
